// extracted by mini-css-extract-plugin
export var circle = "_hf-1";
export var exitConfirmationModal = "_hf-5";
export var iframe = "_hf-0";
export var offline = "_hf-3";
export var online = "_hf-2";
export var workstationSelectError = "_hf-4";